
import { defineComponent, SetupContext, PropType, ref, watch } from "vue";
import SelectCategoryItem from "@/components/common/SelectCategoryItem.vue";
import NativeClient from "@/client/native-client";

export default defineComponent({
  name: "SelectCategory",
  components: { SelectCategoryItem },
  props: {
    /**
     * 分類名
     */
    categoryNameList: {
      type: Array as PropType<string[]>,
      required: true
    },
    /**
     * 初期選択位置
     */
    selectIndex: {
      type: Number,
      default: 0
    }
  },
  setup(props, context: SetupContext) {
    NativeClient.sendDebugLog("SelectCategory setup start");
    // 表示更新のためのリアクティブ
    const updateDisplayKey = ref(0);
    const updateDisplay = () => {
      if (updateDisplayKey.value == 100) {
        updateDisplayKey.value = 0;
      } else {
        updateDisplayKey.value++;
      }
    };

    // SelectIngredientCategoryで使用する型
    class DisplayCategory {
      index: number;
      categoryName: string;
      isSelect: boolean;
      constructor() {
        this.index = 0;
        this.categoryName = "";
        this.isSelect = false;
      }
    };
    
    const categoryArray = ref(Array<DisplayCategory>());

    const updateCategoryList = (selectIndex: number) => {
      NativeClient.sendDebugLog("SelectCategory categoryArray selectIndex = " + selectIndex);
      if (props.categoryNameList == null || props.categoryNameList.length == 0) {
        NativeClient.sendDebugLog("SelectCategory categoryArray null");
        categoryArray.value = Array<DisplayCategory>();
        return;
      }
      const categoryInfoArray = Array<DisplayCategory>()
      props.categoryNameList.forEach((category, index) => {
          const categoryInfo = new DisplayCategory();
          categoryInfo.index = index;
          categoryInfo.categoryName = category;
          categoryInfo.isSelect = selectIndex == index ? true : false;
          categoryInfoArray.push(categoryInfo);            
      })
      NativeClient.sendDebugLog("SelectCategory categoryArray result = " + JSON.stringify(categoryInfoArray));
      categoryArray.value = categoryInfoArray
    };

    updateCategoryList(props.selectIndex);

    const selectCategory = (index: number, left: number, right: number, categoryName: string) => {
      NativeClient.sendDebugLog("SelectCategory selectCategory start index = " + index + ", left = " + left + ", right = " + right + ", categoryName = " + categoryName)
      if (categoryArray.value == null || categoryArray.value?.length == 0) {
        return
      }
      if (!categoryArray.value[index].isSelect) {
        updateCategoryList(index);
        NativeClient.sendDebugLog("SelectCategory selectCategoryUpdate");
        context.emit("on-select", index);
      }

      // スクロール位置の調整（選択されたカテゴリ名の要素全体が画面内に表示させる）
      if (index == 0) {
        // 左端を指定しているので、最左端までスクロール
        const targetElement = document.getElementById("selectCategoryComponentTop");
        targetElement?.scroll({ top: 0, left: 0, behavior: 'smooth'});
      } else {
        // SelectCategoryItemから返却されるleft、rightは、現在のスクロール位置の相対値
        const targetElement = document.getElementById("selectCategoryComponentTop");
        if (targetElement == undefined || targetElement == null) {
          NativeClient.sendDebugLog("SelectCategory selectCategory display area undefined");
        } else {
          NativeClient.sendDebugLog("SelectCategory selectCategory display area not undefined");
          const elementWidth = targetElement.clientWidth;
          const currentScrollPosition = targetElement.scrollLeft;
          NativeClient.sendDebugLog("SelectCategory selectCategory scroll currentPosition = " + currentScrollPosition + ", elementWidth = " + elementWidth);
          if (left < 0) {
            // 左にはみ出している
            NativeClient.sendDebugLog("SelectCategory selectCategory scroll left");
            targetElement.scroll({ top: 0, left: currentScrollPosition + left, behavior: 'smooth'});
          } else if (elementWidth < right) {
            // 右にはみ出している
            NativeClient.sendDebugLog("SelectCategory selectCategory scroll right");
            targetElement.scroll({ top: 0, left: currentScrollPosition + (right - elementWidth), behavior: 'smooth'});
          }
        }
      }
    };

    return {
      categoryArray,
      selectCategory
    };
  }
});
